import React from 'react'
import ErrorMsg from './NewMsgErr'
import MaxCharactersNote from './MaxCharactersNote'

export default function OldInput({
  isEdit,
  formik,
  name,
  errors,
  child,
  style,
  min,
  type,
  onBlur,
  max,
  withoutBorder,
  notMsgErr,
  characters,
  permalinkFun,
}: any) {
  return (
    <>
      {' '}
      <input
        maxLength={characters || max || 'auto'}
        style={{
          ...style,
          border: withoutBorder ? '1px solid #e1e3ea00 !important' : '1px solid var(--bs-gray-300)',
        }}
        min={min}
        className={`form-control ${!withoutBorder && 'mb-2'}  form-control-lg`}
        disabled={isEdit}
        type={type || 'text'}
        {...formik?.getFieldProps(child ? `${name}[${child}]` : `${name}`)}
        onBlur={() => {
          if (permalinkFun) {
            permalinkFun()
          } else {
            onBlur()
          }
        }}
      />
      <MaxCharactersNote characters={characters} />
      {!notMsgErr && errors && !child && errors[name] && typeof errors[name] === 'string' ? (
        <ErrorMsg msgErr={errors[name]} />
      ) : errors &&
        child &&
        errors[`${name}.${child}`] &&
        typeof errors[`${name}.${child}`] === 'string' ? (
        <ErrorMsg child={child} msgErr={errors[`${name}.${child}`]} />
      ) : (
        ''
      )}
    </>
  )
}
